import {Component, inject} from '@angular/core'
import {ListComponent} from 'src/app/shared/ui/list/list.component'
import {NgIf} from '@angular/common'
import {ComiteListComponent} from '../comite-list/comite-list.component'
import {FiltersComponent} from 'src/app/shared/ui/filters/filters.component'
import {DataImmuablesDomainService} from "../../../core/domain/data-immuables.domain";

@Component({
    selector: 'app-comites-membre',
    templateUrl: './comites-membre.component.html',
    styleUrls: ['./comites-membre.component.scss'],
    imports: [
        FiltersComponent,
        ComiteListComponent,
        NgIf,
        ListComponent,
    ]
})
export class ComitesMembreComponent {
    private dataImmuablesDomain = inject(DataImmuablesDomainService)

    constructor() {
        this.dataImmuablesDomain.setComite().subscribe()
    }

}
